import React,  { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';
import AddItemForm from './AddItemForm';
import { get, find } from 'lodash';
import { ADD_ITEM_FORM, ADD_ITEMS_FORM } from '../../constants/formNames';

class AddItemFormContainer extends Component {
  constructor (props) {
    super(props);


    this.editAddOnAction = this.editAddOnAction.bind(this);
    this.handleItemChange = this.handleItemChange.bind(this);
  }

  editAddOnAction (e) {
    e.preventDefault();

    const { getInventoryItem, toggleModal, itemId } = this.props;

    getInventoryItem(itemId);
    toggleModal('editAddOnModal');
  }

  handleItemChange (itemId) {
    const { dispatch, inventory } = this.props;
    const item = find(inventory, { _id: itemId });

    dispatch(change(ADD_ITEM_FORM, 'unit_cost', item.unit_cost));
  }

  render () {
    const priceOptions = [
      { value: 'per_item', label: 'per item' },
      { value: 'per_person', label: 'per person' },
      { value: 'per_hour', label: 'per hour' },
      { value: 'flat_fee', label: 'flat fee' }
    ];

    return (
      <AddItemForm
        {...this.props}
        priceOptions={priceOptions}
        editAddOnAction={this.editAddOnAction}
        handleItemChange={this.handleItemChange}
      />
    );
  }
}


AddItemFormContainer.propTypes = {
  getInventoryItem: PropTypes.func,
  toggleModal: PropTypes.func
};

const selector = formValueSelector(ADD_ITEM_FORM);

function mapStateToProps (state, ownProps) {
  const forms = get(state, 'form');
  const inventory = get(state, 'inventory.data.inventory');
  const itemId = selector(state, 'title');
  const isEditModal = get(ownProps, 'isEditModal', false);
  const inventoryItem = get(state, 'inventory.item');
  const addItemsForm = get(forms, ADD_ITEMS_FORM);
  const bookingAddOns = get(addItemsForm, 'values.addOns', []);
  const addOnIndex = get(state, 'add_ons.index', '');
  const selectedAddOn = bookingAddOns[addOnIndex];

  const returnObj = {
    inventory,
    itemId,
    isEditModal,
    inventoryItem
  };

  if (isEditModal && selectedAddOn) {
    const item = find(inventory, { _id: selectedAddOn._id });
    const itemDetails = {
      ...item,
      title: selectedAddOn._id,
      unit_cost: get(selectedAddOn, 'unit_cost'),
      count: get(selectedAddOn, 'count'),
      description: get(selectedAddOn, 'description', null)
    };

    return {
      ...returnObj,
      initialValues: {
        ...itemDetails
      }
    };
  }

  if (itemId) {
    const itemDetails = find(inventory, { _id: itemId });
    return {
      ...returnObj,
      initialValues: {
        title: itemId,
        unit_cost: (itemDetails.unit_cost).toFixed(2)
      }
    };
  }

  return returnObj;
}

export default connect(mapStateToProps)(AddItemFormContainer);
